import "./index.css";

function FileTypeIcon() {
  return (
    <svg width="40" height="44" viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 10H0.5H2ZM2 34H3.5H2ZM10 42V40.5V42ZM30 42V43.5V42ZM38 34H36.5H38ZM38 21.3137H39.5H38ZM18.6863 2V0.5V2ZM10 2V3.5V2ZM35.6569 15.6569L34.5962 16.7175L35.6569 15.6569ZM24.3431 4.34314L25.4038 3.28248V3.28248L24.3431 4.34314ZM22 10H20.5H22ZM30 18V19.5V18ZM0.5 10L0.500001 34H3.5L3.5 10H0.5ZM10 43.5H30V40.5H10V43.5ZM39.5 34V21.3137H36.5V34H39.5ZM18.6863 0.5L10 0.5V3.5L18.6863 3.5V0.5ZM36.7175 14.5962L25.4038 3.28248L23.2825 5.4038L34.5962 16.7175L36.7175 14.5962ZM18.6863 3.5C20.4102 3.5 22.0635 4.18482 23.2825 5.4038L25.4038 3.28248C23.6222 1.50089 21.2058 0.5 18.6863 0.5V3.5ZM39.5 21.3137C39.5 18.7942 38.4991 16.3778 36.7175 14.5962L34.5962 16.7175C35.8152 17.9365 36.5 19.5898 36.5 21.3137H39.5ZM0.500001 34C0.500001 39.2467 4.7533 43.5 10 43.5V40.5C6.41015 40.5 3.5 37.5899 3.5 34H0.500001ZM3.5 10C3.5 6.41015 6.41015 3.5 10 3.5V0.5C4.75329 0.500001 0.5 4.7533 0.5 10H3.5ZM30 43.5C35.2467 43.5 39.5 39.2467 39.5 34H36.5C36.5 37.5899 33.5899 40.5 30 40.5V43.5ZM20.5 2V10H23.5V2H20.5ZM30 19.5L38 19.5V16.5L30 16.5V19.5ZM20.5 10C20.5 15.2467 24.7533 19.5 30 19.5V16.5C26.4102 16.5 23.5 13.5899 23.5 10H20.5Z" fill="#0D3A5D"/>
    </svg>
  )
}

function DownloadFileWidget({
  file_name = "",
  attachment_file = "",
}) {
  return (
    <div className="ReaderWidget DownloadReaderWidget">
      <div className="DownloadReaderLeft">
        <FileTypeIcon />
        <p className="DownloadReaderWidgetFileName">{file_name}</p>
      </div>
      <div className="DownloadReaderWidgetAction">
        <a
          className="Btn"
          style={{textDecoration: "none" }}
          href={attachment_file}
          download={attachment_file}
          target="_blank"
        >
          Download
        </a>
      </div>
    </div>
  )
}

export { DownloadFileWidget };
